// app/javascript/controllers/toolbar_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tagInput", "tagSubmitButton"];

  connect() {
    this.allVisible = true;
    this.formElement = this.element.closest("form");
    if (this.formElement) {
      this.formElement.addEventListener(
        "submit",
        this.preventEnterSubmit.bind(this),
      );
    }

    this.verifyLength();
  }

  toggleVisibility(e) {
    e.preventDefault();
    const scope = this.element
      .closest("#tagging")
      .querySelectorAll("input[type='checkbox']");
    if (this.allVisible) {
      scope.forEach((element) => {
        const label = element.closest("label");
        if (label) {
          if (!element.checked) {
            label.classList.add("hidden");
          } else {
            label.classList.remove("hidden");
          }
        }
      });
      this.element.querySelector(".allVisible").classList.add("hidden");
      this.element
        .querySelector(".selectionVisible")
        .classList.remove("hidden");
      this.allVisible = false;
    } else {
      scope.forEach((element) => {
        const label = element.closest("label");
        if (label) {
          label.classList.remove("hidden");
        }
      });
      this.element.querySelector(".allVisible").classList.remove("hidden");
      this.element.querySelector(".selectionVisible").classList.add("hidden");
      this.allVisible = true;
    }
  }

  disconnect() {
    if (this.formElement) {
      this.formElement.removeEventListener(
        "submit",
        this.checkFormSubmit.bind(this),
      );
    }
  }

  clearTagInput() {
    setTimeout(() => {
      this.tagInputTarget.value = "";
      this.verifyLength();
    }, 300);
  }

  verifyLength() {
    if (this.tagInputTarget.value.length > 1) {
      this.tagSubmitButtonTarget.classList.remove(
        "opacity-50",
        "pointer-events-none",
      );
    } else {
      this.tagSubmitButtonTarget.classList.add(
        "opacity-50",
        "pointer-events-none",
      );
    }
  }

  addTag(e) {
    e.preventDefault();

    const inputValue = this.tagInputTarget.value;
    const form = e.target.closest("form");

    if (e.target.dataset.tagType === "main") {
      // Unselect all existing radio buttons
      form
        .querySelectorAll('input[name="post[main_tag_list][]"][type="radio"]')
        .forEach((radio) => {
          radio.checked = false;
        });

      // Create a hidden field for main tag
      const hiddenField = document.createElement("input");
      hiddenField.type = "hidden";
      hiddenField.name = "post[main_tag_list][]";
      hiddenField.value = inputValue;

      // Append to form
      form.appendChild(hiddenField);
    } else {
      // Create a hidden field for regular tag
      const hiddenField = document.createElement("input");
      hiddenField.type = "hidden";
      hiddenField.name = "post[tag_list][]";
      hiddenField.value = inputValue;

      // Append to form
      form.appendChild(hiddenField);
    }

    form.querySelector("[type='submit']").click();
  }

  preventEnterSubmit(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }
}
